<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<DeleteGoalReferenceConfirm
			v-if="action === 'deleting' && goalDeleted"
			@close="closeModal"
			@submit="deleteLib(goalDeleted.id)"
			:in-progress="inProgress"
		/>
		<CreateGoalReference
			v-if="action === 'creating' && !goalDeleted"
			@close="modalIsOpen = false"
			@submit="createGoalReference"
			:in-progress="inProgress"
			:error="error"
		/>
		<UpdateGoalReference
			v-if="action === 'updating' && goalUpdated"
			@close="modalIsOpen = false"
			@submit="updateGoalReference"
			:data="goalUpdated"
			:in-progress="inProgress"
			:error="error"
		/>
		<CopyGoalReferenceConfirm
			v-if="action === 'copy'"
			@close="modalIsOpen = false"
			@submit="bulkCopy"
			:in-progress="inProgress"
		/>
		<Upgrade v-if="action === 'upgrade'" @close="modalIsOpen = false" />
	</DaModalFrame>
	<div v-if="isSlideOpen" :class="isSlideOpen ? 'side-over--active' : ''">
		<div
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="isSlideOpen = false"
		></div>
		<ChangeStatus
			:goalChanged="goalChanged"
			@success="changeStatusSuccess"
		/>
	</div>
	<div>
		<div class="__report-lesson px-12 md-down:px-4 pb-10">
			<div
				class="__report-lesson__header pt-10 flex flex-wrap gap-6 md:flex-nowrap justify-between items-center"
			>
				<div
					class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl gap-4"
				>
					<svg
						width="28"
						height="28"
						viewBox="0 0 28 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M25.2202 9.67713C25.1293 8.85957 25.1293 7.49697 25.8561 7.04277C25.8561 7.04277 25.8561 7.04277 25.9469 7.04277C26.4919 6.86109 26.9461 6.58857 26.5828 6.22521L17.6804 3.5L3.23685 5.49848C3.23685 5.49848 1.60172 5.77101 1.69256 8.31453C1.7834 9.67713 2.2376 10.4039 2.60096 10.7672L1.42004 11.1306C1.14752 11.4939 1.51088 11.7665 2.14676 11.9481C2.87348 12.4023 2.87348 13.7649 2.78264 14.5825C0.148278 15.3092 1.05668 15.5817 1.05668 15.5817L1.69256 15.7634C1.23836 16.1268 0.875 16.8535 0.875 18.1253C1.05668 20.7596 2.41928 20.8505 2.41928 20.8505L11.8667 23.939L26.1286 20.4871C26.1286 20.4871 27.1278 20.3054 24.4935 19.4879C24.3118 18.6703 24.3118 17.3077 25.0385 16.8535C25.1293 16.8535 25.1293 16.8535 25.1293 16.8535C25.6744 16.6718 26.1286 16.3993 25.7652 16.036L25.2202 15.8543C25.5835 15.5817 26.2194 14.9459 26.3103 13.2199C26.4011 12.039 26.0377 11.4031 25.7652 10.9489L26.9461 10.6764C26.9461 10.6764 27.9454 10.4039 25.2202 9.67713ZM13.3201 9.67713L15.682 9.13209L23.8576 7.49697L25.0385 7.22445C24.6751 7.95117 24.6751 8.95041 24.766 9.49545C24.766 9.67713 24.766 9.76798 24.766 9.94966L23.4942 10.2222L13.2293 12.7657L13.3201 9.67713ZM2.96432 12.1298L4.23609 12.4023L11.9575 14.0375L12.6842 14.1283L14.6827 14.5825L14.8644 17.6711L4.32693 15.0367L3.23685 14.855C3.23685 14.7642 3.32769 14.5825 3.32769 14.4917C3.32769 13.8558 3.41853 12.8565 2.96432 12.1298ZM2.51012 8.22369C2.51012 7.49697 2.60096 7.04277 2.87348 6.77025C3.05517 6.58857 3.23685 6.58857 3.32769 6.58857C3.41853 6.58857 3.50937 6.58857 3.50937 6.58857L9.6865 8.58705L12.7751 9.58629L12.6842 12.7657L3.96357 10.313L3.50937 10.2222C3.41853 10.2222 2.60096 10.1313 2.51012 8.22369ZM11.8667 22.5764L2.6918 20.0329C2.60096 20.0329 1.7834 19.9421 1.69256 18.0344C1.69256 17.3077 1.87424 16.8535 2.05592 16.581C2.2376 16.3993 2.41928 16.3993 2.51012 16.3993C2.60096 16.3993 2.6918 16.3993 2.6918 16.3993L12.0483 19.4879L11.8667 22.5764ZM23.9484 19.397C23.9484 19.4879 23.9484 19.6696 23.9484 19.7604L12.4117 22.5764L12.5025 19.4879L14.9552 18.9428L15.3186 19.0337L16.6812 18.5795L23.04 17.3077L24.2209 17.0352C23.8576 17.7619 23.8576 18.7612 23.9484 19.397ZM24.5843 15.1275H24.4935L23.6759 15.4001L15.3186 17.6711L15.2278 14.5825L17.953 13.6741L24.5843 11.4939C24.5843 11.4939 24.8568 11.4031 25.1293 11.6756C25.4019 11.9481 25.4927 12.4023 25.4927 13.1291C25.4927 15.0367 24.5843 15.1275 24.5843 15.1275Z"
							fill="#65758B"
						/>
					</svg>

					Thư viện tham khảo
				</div>
				<div class="w-full flex items-center justify-end">
					<div
						class="search-input max-w-lg w-full"
						style="min-width: 160px"
					>
						<div class="input-group input--lg">
							<input
								type="text"
								placeholder="Tìm theo tên mục tiêu"
								class="bg-white input-with-icon"
								v-model="searchQuery"
								@keyup="searching"
								@keypress.enter="search"
							/>
							<div class="input-icon absolute top-1/2">
								<DaIcon
									name="das--search"
									class="h-4 w-4 text-neutral-400"
								/>
							</div>
						</div>
					</div>
					<Menu v-if="isLucaEducation" as="div" class="ml-3 relative">
						<div>
							<MenuButton
								class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
							>
								<span class="sr-only">Open user menu</span>
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
										fill="#94A3B8"
									/>
								</svg>
							</MenuButton>
						</div>
						<transition
							enter-active-class="transition ease-out duration-200"
							enter-from-class="transform opacity-0 scale-95"
							enter-to-class="transform opacity-100 scale-100"
							leave-active-class="transition ease-in duration-75"
							leave-from-class="transform opacity-100 scale-100"
							leave-to-class="transform opacity-0 scale-95"
						>
							<MenuItems
								class="origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
							>
								<MenuItem @click="openModalCreated">
									<div
										class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
									>
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
												fill="#94A3B8"
											/>
										</svg>
										<span> Tạo thư viện mới</span>
									</div>
								</MenuItem>
							</MenuItems>
						</transition>
					</Menu>
				</div>
			</div>
			<div class="w-full mt-8 flex items-center justify-end">
				<button
					type="button"
					class="button-p text-center whitespace-nowrap w-fit px-4 btn--ghost"
					@click="openModalCopy"
					:disabled="!selectedList?.length"
				>
					<img
						v-if="selectedList?.length > 0"
						src="@/assets/images/icons/yellow-move.png"
						alt=""
					/>
					<img
						v-else
						src="@/assets/images/icons/direction.png"
						alt=""
					/>
					<span class="ml-2">Đưa vào thư viện nội bộ</span>
				</button>
			</div>
			<div v-if="!isLoading" class="mt-8 lg-down:overflow-x-auto">
				<div>
					<div v-if="!searchQuery">
						<div v-if="goals.length">
							<div class="mb-10">
								<div class="shadow-sm sm:rounded-2xl">
									<div class="__record__table scroll-bar">
										<div
											class="sm:rounded-t-2xl w-full min-w-full"
										>
											<table
												class="w-full table-fixed divide-y text-neutral-200 rounded-2xl"
											>
												<thead
													class="bg-neutral-100 h-16 rounded-2xl"
												>
													<tr>
														<th
															class="py-3 pl-3 w-10"
														>
															<Checkbox
																:value="
																	isSelectedAll
																"
																@click.stop="
																	onSelectAll
																"
															/>
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-10 whitespace-nowrap"
														>
															STT
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
															@click="
																sortBy =
																	sortBy !==
																	'goal_name_asc'
																		? 'goal_name_asc'
																		: 'goal_name_desc'
															"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																tên thư viện
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
																		fill="#94A3B8"
																	/>
																</svg>
															</div>
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16"
														>
															tài liệu
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-20"
															@click="
																sortBy =
																	sortBy !==
																	'goal_count_asc'
																		? 'goal_count_asc'
																		: 'goal_count_desc'
															"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																mục tiêu
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
																		fill="#94A3B8"
																	/>
																</svg>
															</div>
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-20"
															@click="
																sortBy =
																	sortBy !==
																	'skill_count_asc'
																		? 'skill_count_asc'
																		: 'skill_count_desc'
															"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																lĩnh vực
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
																		fill="#94A3B8"
																	/>
																</svg>
															</div>
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-24"
														>
															độ tuổi
														</th>
														<th
															v-if="
																isLucaEducation
															"
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-48"
															@click="
																sortBy =
																	sortBy !==
																	'updated_at_asc'
																		? 'updated_at_asc'
																		: 'updated_at_desc'
															"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																chỉnh sửa cuối
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
																		fill="#94A3B8"
																	/>
																</svg>
															</div>
														</th>
														<th
															v-if="
																isLucaEducation
															"
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-24"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																Trạng thái
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
																		fill="#94A3B8"
																	/>
																</svg>
															</div>
														</th>

														<th
															v-if="
																isLucaEducation
															"
															class="w-10"
														></th>
													</tr>
												</thead>
												<tbody>
													<tr
														v-for="(
															goal, i
														) in goals"
														:key="goal.id"
														:class="
															i % 2 === 0
																? 'bg-white'
																: 'bg-neutral-50'
														"
														class="text-neutral-700 hover:bg-orange-50 cursor-pointer"
														@click.prevent="
															checkMode(goal)
														"
													>
														<td class="pl-3 w-10">
															<Checkbox
																:disabled="
																	!goal?.is_published
																"
																:value="
																	isSelected(
																		goal
																	)
																"
																@click.stop="
																	goal?.is_published &&
																		onSelect(
																			goal
																		)
																"
															/>
														</td>
														<td
															class="px-3 whitespace-nowrap text-neutral-700"
														>
															{{ i + 1 }}
														</td>
														<td
															class="px-3 py-4 text-neutral-700"
														>
															<div
																v-html="
																	goal?.name
																"
															></div>

															<div
																class="text-neutral-400 truncate-text-2-rows"
															>
																{{
																	goal?.description
																}}
															</div>
														</td>
														<td
															class="px-3 py-4 text-neutral-700 text-center"
														>
															<img
																v-if="
																	goal.goal_library_file !=
																	null
																"
																@click.stop="
																	download(
																		goal.goal_library_file
																	)
																"
																src="@/assets/images/icons/download.png"
															/>
														</td>
														<td
															class="px-3 text-neutral-700"
														>
															{{
																goal?.numbers_of_goal ||
																'-'
															}}
														</td>
														<td
															class="px-3 py-4 text-neutral-700"
														>
															{{
																goal?.numbers_of_skill ||
																'-'
															}}
														</td>
														<td
															class="px-3 py-4 text-neutral-700"
														>
															<div
																class="break-words whitespace-normal"
															>
																{{
																	goal?.display_age_range ||
																	'-'
																}}
															</div>
														</td>
														<td
															v-if="
																isLucaEducation
															"
															class="px-3 text-neutral-700 py-4"
														>
															<div>
																<div
																	class="flex items-center mb-4"
																	v-if="
																		goal.updated_by_staff
																	"
																>
																	<div>
																		<img
																			class="shadow-sm inline-block h-9 w-9 rounded-full"
																			:src="
																				goal
																					.updated_by_staff
																					?.profile_photo
																					?.w200
																			"
																			alt=""
																			v-if="
																				goal
																					.updated_by_staff
																					?.profile_photo
																					?.w200
																			"
																		/>
																		<span
																			v-else
																			class="inline-flex items-center justify-center h-9 w-9 rounded-full"
																			:style="{
																				background:
																					goal
																						.updated_by_staff
																						?.profile_photo
																						?.default
																						?.color,
																			}"
																		>
																			<span
																				class="font-medium leading-none text-white text-xs"
																				>{{
																					goal
																						.updated_by_staff
																						?.profile_photo
																						?.default
																						?.initial
																				}}</span
																			>
																		</span>
																	</div>
																	<div
																		class="ml-4 text-blue-600 font-semibold truncate"
																	>
																		{{
																			goal
																				.updated_by_staff
																				.name
																		}}
																	</div>
																</div>
																<div
																	v-if="
																		goal.last_updated_at
																	"
																>
																	{{
																		$filters.formatDateTime(
																			goal.last_updated_at
																		)
																	}}
																</div>
															</div>
														</td>
														<td
															v-if="
																isLucaEducation
															"
															class="px-3 text-neutral-700 whitespace-nowrap"
														>
															<div
																v-if="
																	goal?.is_published
																"
																class="text-green-600"
															>
																Công khai
															</div>
															<div v-else>
																Bản nháp
															</div>
														</td>

														<td
															v-if="
																isLucaEducation
															"
															class="w-10"
														>
															<Menu
																as="div"
																class="relative"
															>
																<div>
																	<MenuButton
																		@click.stop="
																			() => {}
																		"
																		class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 p-3"
																	>
																		<span
																			class="sr-only"
																			>Open
																			user
																			menu</span
																		>
																		<svg
																			width="20"
																			height="20"
																			viewBox="0 0 20 20"
																			fill="none"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			<path
																				fill-rule="evenodd"
																				clip-rule="evenodd"
																				d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																				fill="#94A3B8"
																			/>
																		</svg>
																	</MenuButton>
																</div>
																<transition
																	enter-active-class="transition ease-out duration-200"
																	enter-from-class="transform opacity-0 scale-95"
																	enter-to-class="transform opacity-100 scale-100"
																	leave-active-class="transition ease-in duration-75"
																	leave-from-class="transform opacity-100 scale-100"
																	leave-to-class="transform opacity-0 scale-95"
																>
																	<MenuItems
																		class="origin-top-right absolute right-0 mt-2 w-60 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
																	>
																		<MenuItem
																			@click.stop="
																				openModalUpdated(
																					goal
																				)
																			"
																		>
																			<div
																				class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																			>
																				<svg
																					width="16"
																					height="16"
																					viewBox="0 0 16 16"
																					fill="none"
																					xmlns="http://www.w3.org/2000/svg"
																				>
																					<path
																						fill-rule="evenodd"
																						clip-rule="evenodd"
																						d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9666 5.14509C14.6009 4.39841 14.6009 3.30223 13.9666 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.8549 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33097 3.54801C10.0746 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87631 5.00267L2.86271 10.0163C2.43765 10.4413 2.22512 10.6539 2.08538 10.915C1.94565 11.1761 1.8867 11.4708 1.76881 12.0602L1.37316 14.0385C1.30663 14.3711 1.27337 14.5374 1.36798 14.632C1.46259 14.7266 1.62889 14.6934 1.9615 14.6269L3.93978 14.2312L3.9398 14.2312L3.93982 14.2312C4.52925 14.1133 4.82397 14.0544 5.08506 13.9146C5.34615 13.7749 5.55867 13.5624 5.98371 13.1373L5.98374 13.1373L5.98374 13.1373L11.0117 8.10931C9.75108 7.3111 8.682 6.24922 7.87631 5.00267Z"
																						fill="#94A3B8"
																					/>
																				</svg>

																				<span
																					>Chỉnh
																					sửa
																					thư
																					viện
																				</span>
																			</div>
																		</MenuItem>
																		<MenuItem
																			@click.stop="
																				openSlide(
																					goal
																				)
																			"
																		>
																			<div
																				class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																			>
																				<img
																					class="h-4 w-4"
																					src="@/assets/images/icons/premium.png"
																					alt=""
																				/>
																				<span
																					>Quyền
																					truy
																					cập
																				</span>
																			</div>
																		</MenuItem>
																		<MenuItem
																			@click.stop="
																				openModalDeleted(
																					goal
																				)
																			"
																		>
																			<div
																				class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																			>
																				<svg
																					width="16"
																					height="16"
																					viewBox="0 0 16 16"
																					fill="none"
																					xmlns="http://www.w3.org/2000/svg"
																				>
																					<path
																						fill-rule="evenodd"
																						clip-rule="evenodd"
																						d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
																						fill="#94A3B8"
																					/>
																				</svg>
																				<span
																					>Xoá
																					thư
																					viện</span
																				>
																			</div>
																		</MenuItem>
																	</MenuItems>
																</transition>
															</Menu>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-else
							class="w-full h-full flex items-center justify-center flex-col"
						>
							<img
								src="@/assets/images/illustrations/not_found.png"
								alt=""
								height="250"
								width="250"
							/>
							<div
								class="text-neutral-400 text-lg text-center"
								style="max-width: 900px"
							>
								Trung tâm chưa có thư viện tham khảo nào. <br />
								<br />Thư viện tham khảo là nơi lưu trữ hệ thống
								mục tiêu tham khảo do trung tâm thiết lập dành
								cho tất cả các trẻ đang học tại cơ sở. Từ thư
								viện tham khảo bạn có thể lựa chọn mục tiêu phù
								hợp đưa vào ngân hàng mục tiêu để cá nhân hóa kế
								hoạch can thiệp.<br />
								<br />
								Trong thư viện tham khảo bạn có thể tạo ra nhiều
								thư viện tham khảo nhỏ hơn theo nhu cầu của
								trung tâm dựa trên phân cấp độ tuổi, lĩnh vực
								hoặc dạng rối loạn ... của trẻ.
							</div>
							<div v-if="isAdmin" class="mt-8">
								<button
									type="button"
									class="button-p text-center shadow-none flex items-center justify-center w-fit px-6 bg-none btn--ghost"
									@click="openModalCreated"
								>
									Tạo mới
								</button>
							</div>
						</div>
					</div>
					<div v-else>
						<div v-if="goalsSearch.length">
							<div class="mb-10">
								<div class="shadow-sm sm:rounded-2xl">
									<div class="__record__table scroll-bar">
										<div
											class="sm:rounded-t-2xl w-fit min-w-full"
										>
											<table
												class="min-w-full divide-y text-neutral-200 rounded-2xl"
											>
												<thead
													class="bg-neutral-100 h-16 rounded-2xl"
												>
													<tr>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-10 whitespace-nowrap"
														>
															STT
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																Tên mục tiêu
															</div>
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
															@click="
																sortSearchBy =
																	sortSearchBy ===
																	'skill_name_asc'
																		? 'skill_name_desc'
																		: 'skill_name_asc'
															"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																lĩnh vực
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
																		fill="#94A3B8"
																	/>
																</svg>
															</div>
														</th>
														<th
															scope="col"
															class="p-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
														>
															<div
																class="flex items-center gap-1 justify-between cursor-pointer"
															>
																Vị trí
															</div>
														</th>
													</tr>
												</thead>
												<tbody>
													<tr
														v-for="(
															goal, i
														) in goalsSearch"
														:key="goal.id"
														:class="
															i % 2 === 0
																? 'bg-white'
																: 'bg-neutral-50'
														"
														class="text-neutral-700 hover:bg-orange-50 cursor-pointer"
														@click.prevent="
															$router.push(
																`/goal-reference-folders/${goal.id}`
															)
														"
													>
														<td
															class="px-6 py-4 whitespace-nowrap text-neutral-700"
														>
															<div class="ml-2">
																{{ i + 1 }}
															</div>
														</td>
														<td
															class="px-6 py-4 text-neutral-700"
														>
															<div
																class="flex items-center gap-2"
																v-html="
																	goal?.name
																"
															></div>
														</td>
														<td
															class="px-6 py-4 text-neutral-700"
															style="width: 300px"
														>
															<div
																class="flex items-center gap-2"
															>
																{{
																	skills.find(
																		(s) =>
																			s.id ===
																			goal.skill_id
																	)?.name ||
																	'-'
																}}
															</div>
														</td>
														<td
															class="px-6 py-4 text-neutral-700"
														>
															<div
																v-if="
																	goal.path &&
																	goal.path
																		.length
																"
																class="flex items-center flex-wrap hover:text-yellow-700 active:text-yellow-500"
																style="
																	max-width: 240px;
																"
																@click.stop="
																	$router.push(
																		{
																			path: `/goal-folders/${goal.path[0].goal_library_id}`,
																			query: {
																				goal_id:
																					goal.id,
																			},
																		}
																	)
																"
															>
																<div
																	class="whitespace-nowrap"
																	v-for="(
																		p, index
																	) in goal.path"
																	:key="index"
																>
																	<span
																		v-if="
																			index !==
																			0
																		"
																		class="mx-2"
																		>></span
																	>
																	{{ p.name }}
																</div>
															</div>
															<div v-else>-</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-else
							class="w-full h-full flex items-center justify-center flex-col"
						>
							<img
								src="@/assets/images/illustrations/not_found.png"
								alt=""
								height="250"
								width="250"
							/>
							<div
								class="text-neutral-400 text-lg text-center"
								style="max-width: 900px"
							>
								Rất tiếc, chúng tôi không thể tìm thấy kết quả
								cho tìm kiếm của bạn.
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="fixed top-1/2 left-1/2">
				<Loading />
			</div>
		</div>
	</div>
</template>

<script>
import Loading from '@/components/common/Loading';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import CreateGoalReference from '@/views/goalReference/features/CreateGoalReference';
import { $api } from '@/services';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DeleteGoalReferenceConfirm from '@/views/goalReference/features/DeleteGoalReferenceConfirm';
import UpdateGoalReference from '@/views/goalReference/features/UpdateGoalReference';
import DaIcon from '@/components/elements/daIcon/DaIcon';
import Checkbox from '@/components/elements/checkbox/Checkbox.vue';
import CopyGoalReferenceConfirm from '@/views/goalReference/features/CopyGoalReferenceConfirm.vue';
import ChangeStatus from '@/views/goalReference/features/ChangeStatusReference.vue';
import Upgrade from '@/views/goalLib/features/Upgrade.vue';

export default {
	name: 'GoalReference',
	components: {
		CopyGoalReferenceConfirm,
		Checkbox,
		DaIcon,
		UpdateGoalReference,
		DeleteGoalReferenceConfirm,
		CreateGoalReference,
		DaModalFrame,
		Loading,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
		ChangeStatus,
		Upgrade,
	},

	data() {
		return {
			isLoading: true,
			modalIsOpen: false,
			goals: [],
			goalsSearch: [],
			skills: [],
			goalDeleted: null,
			goalUpdated: null,
			inProgress: false,
			error: '',
			action: '',
			sortBy: '',
			sortSearchBy: 'skill_name_desc',
			typing: '',
			searchQuery: '',
			selectedList: [],
			isSlideOpen: false,
			goalChanged: null,
		};
	},

	created() {
		this.fetchAllGoalReference();
		this.fetchSkills();
	},

	computed: {
		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		isSelectedAll() {
			return this.selectedList.length === this.goals.length;
		},

		isLucaEducation() {
			return (
				this.$store?.state?.profile?.current_org?.subdomain ===
				'luca_education'
			);
		},
		isPaidCenter() {
			return this.$store?.state?.profile?.is_paid_center;
		},
	},

	watch: {
		sortBy() {
			this.fetchAllGoalReference();
		},

		sortSearchBy() {
			this.fetchAllGoalReferenceSearch();
		},

		typing(value) {
			this.isLoading = !!value;
		},
	},

	methods: {
		openSlide(val) {
			this.goalChanged = val;
			this.isSlideOpen = true;
		},
		changeStatusSuccess() {
			this.isSlideOpen = false;
			this.fetchAllGoalReference();
		},
		checkMode(val) {
			if (val.paid_mode == false || this.isPaidCenter) {
				this.$router.push(`/goal-reference-folders/${val.id}`);
			} else {
				this.$store.dispatch('setAlertMessage', {
					message:
						'Đăng ký gói trả phí để xem chi tiết nội dung thư viện',
					type: 'danger',
				});
			}
		},
		isSelected(item) {
			return this.selectedList.find((s) => s.id === item.id);
		},

		onSelectAll() {
			if (this.isSelectedAll) {
				this.selectedList = [];
			} else {
				this.selectedList = [
					...this.goals.filter((g) => g.is_published),
				];
			}
		},

		onSelect(item) {
			const index = this.selectedList.findIndex((s) => s.id === item.id);

			if (index !== -1) {
				this.selectedList.splice(index, 1);
			} else {
				this.selectedList.push(item);
			}
		},

		async fetchAllGoalReference() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalLib(
					{
						sort_by: this.sortBy,
						query_reference_goal_library: true,
					},
					this.isAdmin
				);
				this.goals = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isLoading = false;
			}
		},

		async fetchSkills() {
			try {
				const {
					data: { data },
				} = await $api.goal.allSkills(this.isAdmin);
				this.skills = data || [];
			} catch (err) {
				console.log(err);
			}
		},

		async fetchAllGoalReferenceSearch() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalLibSearch(
					{
						sort_by: this.sortSearchBy,
						query: this.searchQuery,
						query_reference_goal_library: true,
					},
					this.isAdmin
				);
				this.goalsSearch = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async createGoalReference(data) {
			this.inProgress = true;
			try {
				await $api.goal.createGoalLibrary({
					...data,
					is_reference: true,
				});
				this.closeModal();
				this.$store.dispatch('setAlertMessage', {
					message: 'Tạo thư viện tham khảo thành công',
				});
				await this.fetchAllGoalReference();
			} catch (e) {
				this.error = e?.response?.data?.errors_by_field;
			} finally {
				this.inProgress = false;
			}
		},

		async updateGoalReference(data) {
			this.inProgress = true;
			try {
				await $api.goal.updateGoalLibrary(this.goalUpdated.id, {
					...data,
					is_reference: true,
				});
				this.closeModal();
				this.$store.dispatch('setAlertMessage', {
					message: 'Chỉnh sửa thư viện tham khảo thành công',
				});
				await this.fetchAllGoalReference();
			} catch (e) {
				this.error = e?.response?.data?.errors_by_field;
			} finally {
				this.inProgress = false;
			}
		},

		async deleteLib(id) {
			this.inProgress = true;
			try {
				await $api.goal.deleteGoalLibrary(id, {
					is_reference: true,
				});
				this.closeModal();
				this.$store.dispatch('setAlertMessage', {
					message: 'Đã xoá thư viện',
				});
				await this.fetchAllGoalReference();
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.message?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},

		bulkCopy() {
			this.selectedList.forEach(async (item) => {
				try {
					const res = await $api.goal.copyGoalReference(item.id);
					if (res?.data?.data) {
						this.$store.dispatch('setAlertMessage', {
							message: 'Đã đưa vào Thư viện nội bộ thành công',
						});
					}
				} catch (e) {
					if (e?.response?.data?.message) {
						this.$store.dispatch('setAlertMessage', {
							message:
								e?.response?.data?.message ||
								'Đã có lỗi xảy ra. Vui lòng thử lại',
							type: 'danger',
						});
					}
					if (e?.response?.data?.errors_by_field['name']) {
						this.$store.dispatch('setAlertMessage', {
							message:
								'Tên thư viện ' +
								e?.response?.data?.errors_by_field['name'],
							type: 'danger',
						});
					}
				}
			});
			this.closeModal();
			this.fetchAllGoalReference();
			this.inProgress = false;
		},

		openModalDeleted(goal) {
			this.action = 'deleting';
			this.goalDeleted = goal;
			this.modalIsOpen = true;
		},

		openModalCreated() {
			this.action = 'creating';
			this.goalDeleted = null;
			this.goalUpdated = null;
			this.modalIsOpen = true;
		},

		openModalUpdated(goal) {
			this.action = 'updating';
			this.goalDeleted = null;
			this.goalUpdated = goal;
			this.modalIsOpen = true;
		},

		openModalCopy() {
			this.action = 'copy';
			this.goalDeleted = null;
			this.modalIsOpen = true;
		},

		closeModal() {
			this.action = '';
			this.modalIsOpen = false;
			this.goalDeleted = null;
			this.goalUpdated = null;
		},

		searching() {
			clearInterval(this.typing);
			this.typing = setTimeout(() => {
				this.search();
			}, 500);
		},

		async search() {
			this.isLoading = true;
			if (this.searchQuery) {
				await this.fetchAllGoalReferenceSearch();
			} else {
				await this.fetchAllGoalReference();
			}
			this.isLoading = false;
		},

		download(goal) {
			if (goal.url === null) {
				this.modalIsOpen = true;
				this.action = 'upgrade';
			} else window.open(goal.url, '_blank');
		},
	},
};
</script>

<style scoped>
.truncate-text-2-rows {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; /* Specifies the number of lines to display */
	overflow: hidden;
	text-overflow: ellipsis; /* Adds an ellipsis (...) at the end of the truncated text */
}
</style>